module.exports = __webpack_public_path__ + "src/assets/models/micropipette/tips_holder.fbx";